import { useTranslation } from 'react-i18next'
import { Card, CardContent, Textarea } from '@/components/v2/ui'

interface TitleInputProps {
  value: string
  onChange: (value: string) => void
  titleCount: number
}

export function TitleInput({ value, onChange, titleCount }: TitleInputProps) {
  const { t } = useTranslation()

  const counter = titleCount > 0
    ? <span className="text-xs text-neutral-500 dark:text-neutral-400">{t('amazonTitleTool.input.titlesDetected', { count: titleCount })}</span>
    : null

  return (
    <Card className="rounded-xl shadow-sm border-neutral-200 dark:border-neutral-800">
      <CardContent className="p-6 space-y-3">
        <div className="flex items-center justify-between">
          <label htmlFor="title-input" className="text-sm font-semibold text-neutral-700 dark:text-neutral-200">
            {t('amazonTitleTool.input.label')}
          </label>
          {counter}
        </div>
        <Textarea
          id="title-input"
          rows={6}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={t('amazonTitleTool.input.placeholder')}
          className="font-mono text-sm resize-none"
        />
        <p className="text-xs text-neutral-400 dark:text-neutral-500">
          {t('amazonTitleTool.input.hint')}
        </p>
      </CardContent>
    </Card>
  )
}
